const formatTimeUnit = (unit) => String(unit).padStart(2, '0');

export const formatTime = (time) => {
  const [hours, minutes, seconds] = time.split(':').map(Number);
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  const days = Math.floor(totalSeconds / (24 * 3600));
  const remainingSecondsAfterDays = totalSeconds % (24 * 3600);

  const finalHours = Math.floor(remainingSecondsAfterDays / 3600);
  const remainingSecondsAfterHours = remainingSecondsAfterDays % 3600;

  const finalMinutes = Math.floor(remainingSecondsAfterHours / 60);

  const formattedTime = `${formatTimeUnit(finalHours)}h:${formatTimeUnit(
    finalMinutes
  )}min`;
  return days > 0 ? `${days}d ${formattedTime}` : formattedTime;
};
